import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "QuestionName",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "QuestionOptionName",
    isNumber: true,
  },
];

export const CaseStatusToExplainResult = {
  label: "案件狀態 VS 判讀結果",
  key: "CaseStatusToExplainResult",
  path: "FundusAbnormal/CaseStatusToExplainResult",
  api: "TCS_V_EyesS02",
  render: (options) => (
    <Diagram.FundusAbnormal.CaseStatusToExplainResult {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "CaseStatus",
      field: "CaseStatus",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
